<template>
  <div class="recipe">
    <myNav />
    <div class="bannerx"></div>
    <div class="y1200">
      <div class="about_1">
        <div class="about_1_left">
          <span class="title">关于我们</span><span class="blue"></span>
          <p v-html="about.desc"></p>
        </div>
        <div class="about_1_right"><img :src="about.pic" /></div>
      </div>
      <div class="about_2">
        <div
          class="about_2_left"
          :style="{ background: 'url(' + info.pic + ') no-repeat' }"
        >
          <h1>{{ info.title }}</h1>
          <div class="bai"></div>
          <h2 v-html="info.desc"></h2>
          <p>{{ info.keyword }}</p>
        </div>
        <div class="about_2_part">
          <div class="sj_part" v-for="(item, index) in type" :key="index">
            <div class="img"><img :src="item.pic" /></div>
            <p>{{ item.title }}</p>
          </div>
        </div>
      </div>
      <div class="map">
        <img :src="map.map" />
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/footer";
export default {
  components: {
    Footer,
  },
  data() {
    return {
      about: [],
      info: [],
      map: [],
      type: [],
    };
  },
  created() {
    this.$axios({
      url: "Index/about",
      method: "GET",
     params: {},
    }).then((res) => {
      this.about = res.data.data.about;
      this.info = res.data.data.info;
      this.map = res.data.data.map;
      this.type = res.data.data.type;
    });
  },
  methods: {},
};
</script>
<style scope="scoped">
.about_1 {
  padding-top: 55px;
  height: 500px;
}
.title {
  font-size: 40px;
  padding-right: 10px;
}
.blue {
  display: inline-block;
  width: 43px;
  height: 7px;
  background: #2b1fcd;
}
.about_1 p {
  font-size: 20px;
  width: 575px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 9;
  line-clamp: 9;
  -webkit-box-orient: vertical;
  line-height: 30px;
}
.about_1_left {
  float: left;
  width: 610px;
  padding-right: 40px;
}
.about_1_right {
  float: left;
  width: 540px;
  height: 390px;
  background: #2b1fcd;
  position: relative;
  margin-top: 55px;
}
.about_1_right img {
  width: 507px;
  height: 375px;
  position: absolute;
  left: 33px;
  top: -30px;
  object-fit: cover;
}
.about_2 {
  margin-top: 50px;
  background: url(../assets/images/about_sj.png) no-repeat;
  width: 1196px;
  height: 324px;
  position: relative;
}
.about_2_left {
  position: absolute;
  width: 431px;
  height: 324px;
  border-radius: 20px;
  top: 0;
  left: 0;
  background-size: cover !important;
}
.about_2_left h1 {
  font-size: 40px;
  color: #fff;
  padding-top: 80px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.about_2_left h2 {
  font-size: 30px;
  color: #fff;
  padding-top: 20px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.about_2_left .bai {
  background: #fff;
  width: 36px;
  height: 4px;
  margin: 0 auto;
  margin-top: 20px;
}
.about_2_left p {
  font-size: 20px;
  color: #fff;
  padding-top: 20px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.about_2_part {
  position: absolute;
  width: 730px;
  top: 50px;
  right: 0;
}
.sj_part {
  float: left;
  width: 135px;
  height: 130px;
  padding-left: 20px;
  padding-top: 10px;
}
.sj_part .img {
  width: 57px;
  margin: 0 auto;
}
.sj_part .img img {
  width: 57px;
  height: 57px;
  object-fit: cover;
}
.sj_part p {
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 18px;
}
.map {
  width: 1200px;
  height: 293px;
  margin: 0 auto;
  margin-bottom: 50px;
  margin-top: 50px;
}
.map img {
  width: 1200px;
  height: 293px;
  object-fit: cover;
}
</style>

